import React, { FC } from 'react';
import { IBookChapter } from '../../../../config/api/models/Chapter';
import { TreeItem } from '@material-ui/lab';
import { Icons, SvgIcon } from '../SvgIcon';
import { Theme, useTheme } from '@material-ui/core';
import styled from '@material-ui/core/styles/styled';

type TrajectoryTreeViewItemProps = {
  data: IBookChapter;
  maxDepth?: number;
  depth: number;
  onSelected: (chapterId: string) => void;
  selectedChapter: string;
};

const MaxDepthItem = styled('div')({
  display: 'flex',
  paddingLeft: '0.5rem',
});

const StyledSvgIcon = styled(SvgIcon)<Theme>(({ theme }) => ({
  border: theme.palette.primary.light,
  margin: '0.4rem 1rem',
  borderRadius: 4,
}));

const IconPlaceholder = styled('div')<Theme>(({ theme }) => ({
  border: `1px solid ${theme.palette.grey['600']}`,
  borderRadius: 4,
  margin: '0.4rem 1rem',
  width: '1.8rem',
  height: '1.8rem',
}));

const TrajectoryTreeViewItem: FC<TrajectoryTreeViewItemProps> = ({
  data,
  maxDepth,
  depth,
  onSelected,
  selectedChapter,
}) => {
  const isMaxDepth = depth === maxDepth;
  const theme = useTheme();

  return !!data.childrenChapters && data.childrenChapters.length > 0 ? (
    <TreeItem nodeId={data.id} label={data.title}>
      {data.childrenChapters.map((chapter: IBookChapter, index: number) => {
        return isMaxDepth ? (
          <TreeItem
            key={index}
            nodeId={chapter.id}
            label={
              <MaxDepthItem
                data-selected={chapter.id === selectedChapter}
                onClick={() => onSelected(chapter.id)}
              >
                {chapter.id === selectedChapter ? (
                  <StyledSvgIcon icon={Icons.CHECK} color={theme.palette.primary.main} />
                ) : (
                  <IconPlaceholder />
                )}
                {chapter.title}
              </MaxDepthItem>
            }
          />
        ) : chapter.childrenChapters.length > 0 ? (
          <TrajectoryTreeViewItem
            key={index}
            data={chapter}
            depth={depth + 1}
            maxDepth={maxDepth}
            onSelected={onSelected}
            selectedChapter={selectedChapter}
          />
        ) : (
          <TreeItem key={index} nodeId={chapter.id} label={chapter.title} />
        );
      })}
    </TreeItem>
  ) : (
    <TreeItem nodeId={data.id} label={data.title} />
  );
};

export default TrajectoryTreeViewItem;
